{
  "entities": {
    "warehouses": "Kho hàng | Kho hàng",
    "loadtypes": "Loại hàng | Loại hàng",
    "organizations": "Tổ chức | Tổ chức",
    "orgs": "Tổ chức | Tổ chức"
  }
}
